module.exports = __webpack_public_path__ + "img/viber.4eef5cb4.svg";